exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".h2-log-override {\n    margin-top: 0px !important;\n}\n\n.action-head-pos {\n    padding-right: 18px;\n}\n\n.refresh-btn {\n    cursor: pointer;\n}\n\n.refresh-btn:hover {\n    color: #00bfff;\n}\n\n.custom-lines-button {\n    padding: 0px !important;\n    min-width: 25px !important;\n}\n\n.lines-button-toggole {\n    font-size: 16px;\n    text-decoration: underline;\n}\n\n.log-select {\n    width: 130px;\n    display: inline-block;\n    top: 1px;\n}\n\n.item-divider {\n    height: 24px;\n    display: inline-block;\n    width: 1px;\n    background-color: #ccc;\n    opacity: 0.55;\n    margin-left: 12px;\n    top: 8px;\n    position: relative;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/log/recent-log.component.css
// module id = 816
// module chunks = 0